var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingPlantRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 1.75C11.3696 1.7531 8.84927 2.79629 6.98997 4.65091C5.13068 6.50553 4.08516 9.01966 4.08203 11.6427C4.08203 19.8616 12.5941 27.4168 13.9988 27.4168C15.4034 27.4168 23.9155 19.861 23.9155 11.6427C23.9124 9.0199 22.8667 6.50571 21.0076 4.65091C19.1484 2.79611 16.6282 1.75312 13.9988 1.75H13.9987ZM13.9987 7.09727C15.136 7.09727 16.2268 7.54797 17.0308 8.3503C17.8351 9.15239 18.2869 10.2405 18.2869 11.3751C18.2869 12.5097 17.8351 13.5978 17.0308 14.3999C16.2268 15.2022 15.136 15.6529 13.9987 15.6529C12.8614 15.6529 11.7706 15.2022 10.9666 14.3999C10.1623 13.5978 9.71052 12.5097 9.71052 11.3751C9.71219 10.2409 10.1645 9.1538 10.9682 8.35195C11.772 7.55011 12.8618 7.09892 13.9987 7.09727Z",
    fill: "#FF2828"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.16602,
    y: 7,
    width: 11.6667,
    height: 9.91673,
    fill: "#FF2828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2736 14.8426V12.6331L12.9593 14.8426H12.591V11.5283H11.118V14.8426H10.3815V11.5283H8.90843V14.8426H8.17188V19.9985H19.5881V12.6332L16.2736 14.8426ZM11.486 18.5252H9.64462V16.6838H11.486V18.5252ZM15.1687 18.5252H13.3274V16.6838H15.1687V18.5252Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8803 8.58016C15.8803 9.80207 12.0857 10.4909 11.4746 9.58372C11.2824 9.94431 10.7726 10.0927 10.3774 9.90426C9.72199 9.59132 10.2106 9.98795 9.50198 9.98795C8.90356 9.98795 8.59492 9.33152 9.01838 8.95767C9.49808 8.53436 9.78355 9.01036 10.3145 8.69742C11.0787 8.24712 10.9079 8.94939 11.6835 8.36258C12.1421 8.01545 12.5666 8.29262 13.0584 8.06916C13.8316 7.71761 15.8803 7.12417 15.8803 8.58017L15.8803 8.58016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingPlantRemove);
export default __webpack_public_path__ + "static/media/processing-plant-remove.26360535051764d1e4771b33b84b42f5.svg";
export { ForwardRef as ReactComponent };